/** @publicapi @module resolve */ /** */
export * from './interface';
export * from './resolvable';
export * from './resolveContext';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@uirouter/core/lib-esm/resolve/index.js
// module id = 356
// module chunks = 0